module.exports = __webpack_public_path__ + "static/img/pic_jjyy_bg@2x.33e22429.png";